/* import __COLOCATED_TEMPLATE__ from './intermediate.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class IntermediateTimingComponent extends Component
{
	@service ajax;
	@service socketGuru;

	@tracked selectedBibRecord = null;
	@tracked selectedTimeRecord = null;
	@tracked selectedTimingPointId = null;

	constructor()
	{
		super(...arguments);

		// Bind WebSocket event handler
		this._boundHandleSocketEvent = this._handleSocketEvent.bind(this);
		this.socketGuru.events.addEventListener('newEvent', this._boundHandleSocketEvent);

		// Fetch initial auto-association state from backend
		this.fetchAutoAssociationStatus();
	}

	willDestroy()
	{
		this.socketGuru.events.removeEventListener('newEvent', this._boundHandleSocketEvent);
		super.willDestroy();
	}

	/**
	 * Fetch current auto-association status from backend
	 */
	async fetchAutoAssociationStatus()
	{
		if (!this.args.event || !this.selectedTimingPointId) {
			return;
		}

		try {
			const eventId = this.args.event.id;
			const timingPointId = this.selectedTimingPointId;
			const response = await this.ajax.request(`/events/${eventId}/autoAssociation/intermediate/${timingPointId}/status`);

			// Update local state to match backend
			this.args.event.set('shouldAutoAssociateIntermediate', response.isRunning);
		} catch (error) {
			console.error('Error fetching intermediate auto-association status:', error);
		}
	}

	/**
	 * Handle WebSocket events
	 */
	_handleSocketEvent(event)
	{
		const { eventName, data } = event.detail;

		if (eventName === 'autoAssociationStateChanged') {
			this.handleAutoAssociationStateChange(data);
		}
	}

	/**
	 * Handle auto-association state change from WebSocket
	 */
	handleAutoAssociationStateChange(payload)
	{
		if (!this.args.event || !this.selectedTimingPointId) {
			return;
		}

		const data = JSON.parse(payload);

		// Only update if this is for our event, 'intermediate' type, and matching typeId
		// Convert both to strings for comparison to handle type mismatches
		if (String(data.eventId) === String(this.args.event.id) &&
		    data.type === 'intermediate' &&
		    String(data.typeId) === String(this.selectedTimingPointId)) {
			this.args.event.set('shouldAutoAssociateIntermediate', data.isRunning);
			console.log(`✓ Intermediate auto-association state updated for event ${data.eventId}, timing point ${this.selectedTimingPointId}: ${data.isRunning}`);
		}
	}
	
	@action
	bibRecordClicked(timingRecord)
	{
		this.selectedBibRecord = timingRecord;
	}
	
	@action
	timeRecordClicked(timingRecord)
	{
		this.selectedTimeRecord = timingRecord;
	}
	
	@action
	async toggleAutoAssociate()
	{
		if (!this.args.event || !this.selectedTimingPointId) {
			return;
		}

		const eventId = this.args.event.id;
		const timingPointId = this.selectedTimingPointId;
		const currentStatus = this.args.event.shouldAutoAssociateIntermediate;

		try {
			if (currentStatus) {
				// Stop auto-association
				await this.ajax.post(`/events/${eventId}/autoAssociation/intermediate/${timingPointId}/stop`);
			} else {
				// Start auto-association
				await this.ajax.post(`/events/${eventId}/autoAssociation/intermediate/${timingPointId}/start`);
			}

			// State will be updated via WebSocket event
		} catch (error) {
			console.error('Error toggling intermediate auto-association:', error);

			// Optionally: show error to user or revert optimistic update
		}
	}

	@action
	timingPointSelectionChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.selectedTimingPointId = 0;
		}
		else
		{
			this.selectedTimingPointId = browserEvent.target.value;
		}

		// Fetch auto-association status for the newly selected timing point
		this.fetchAutoAssociationStatus();
	}
}

